const base64FileTypes = {
  'xlsx': 'data:application/octet-stream;charset=utf-8;base64,',
  'zip': 'data:application/zip;base64,',
  'pdf': 'data:application/pdf;base64,'
}

export default function saveFileFromBase64 (data, fileName, fileType) {
  const type = base64FileTypes[fileType]
  const areErrorsPresent = !(type && data && fileType && fileName)

  if (areErrorsPresent) {
    console.error('Unknown fileType during create blob')
    return
  }

  const fullFileName = `${fileName}.${fileType}`
  let blob = new Blob([ data ], { type })
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, fullFileName)
  } else {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fullFileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}



// WEBPACK FOOTER //
// ./src/utils/saveFileFromBase64.js